import { getOrderType } from '../webStorage/manageOrderType';

Array.prototype.EasyEatGroupMenu = function (showOutOfStockItems) {
  if (!this.length) return {};
  try {
    const categories = uniqueElement(this, 'cat_name');
    return {
      categories,
      group: categories.flatMap((cat) => {
        const filterCategory = this.filter(
          (item) =>
            item.cat_name == cat &&
            (showOutOfStockItems || (!showOutOfStockItems && (item?.is_available == 1 || item?.is_available == 2 ))) &&
            isVisibleToUser(item.visible)
        ); // items are availabe when is_avalilabe is 1 or 2
        if (!filterCategory.length) {
          return [];
        }
        return {
          name: cat,
          cat_length: filterCategory.length,
          items: uniqueElement(filterCategory, 'subcat_name').map((subCat) => ({
            name: subCat,
            items: filterCategory.filter((item) => item.subcat_name == subCat),
          })),
        };
      }),
    };
  } catch (error) {
    return {};
  }

  function uniqueElement(array, type) {
    try {
      return [...new Set(array.map((item) => item[type]))];
    } catch (error) {
      return [];
    }
  }
};

Array.prototype.EasyEatMenuItems = function (showOutOfStockItems) {
  if (!this.length) return {};
  try {
    return this.filter(
      (item) =>
      (showOutOfStockItems || (!showOutOfStockItems && (item?.is_available == 1 || item?.is_available == 2 ))) && isVisibleToUser(item.visible)
    ); // items are availabe when is_avalilabe is 1 or 2
  } catch (error) {
    return {};
  }
};

export function isVisibleToUser(visible) {
  const vis = parseInt(visible);
  const orderType = Number(getOrderType(false)) + 1;
  if (orderType == 1) {
    return (vis & 1) === 1;
  } else if (orderType == 2) {
    return (vis & 2) === 2;
  } else if (orderType == 3) {
    return (vis & 4) === 4;
  }
  return false;
}
